import { AddressModel } from './address.model';
export class AddressBookModel {
    name?: any = 'NA';
    shippingAddress?: AddressModel;
    billingAddress?: AddressModel;

    constructor(address) {
        {
            if (address){
                this.name = address.name || null;
                this.shippingAddress = new AddressModel(address.shippingAddress);
                this.billingAddress = new AddressModel(address.shippingAddress);
            }
        }
    }
}
